import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { PrefilteredResourceLibraryItemsProvider } from '../../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import TechnicalResources from '../automotivePage/TechnicalResources';

const YageoGruopVideo: FunctionComponent = () => {
    const { locale, messages } = useLocale();

    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <PrefilteredResourceLibraryItemsProvider
                initialFilters={{
                    resourceTypeKeys: ['Video'],
                }}
            >
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0,
                    }}
                >
                    <TechnicalResources />
                </Box>
            </PrefilteredResourceLibraryItemsProvider>
        </IntlProvider>
    );
};
export default YageoGruopVideo;
